import { infractionFields, municipalFields, roadSignFields } from "../constants/fieldConstants";

/**
 * Reverse transforms a single row (array of values) into an object.
 *
 * @param {Array} fields - The array of field definitions.
 *        Each field should have at least a 'name' property.
 * @param {Array} row - The row of values corresponding to the fields.
 * @returns {Object} The reconstructed object.
 */
export const reverseTransformSingleTraffic = (row) => {
    return infractionFields.reduce((acc, field, index) => {
      acc[field.name] = row[index];
      return acc;
    }, {});
}

export const reverseTransformSingleMunicipal = (row) => {
    return municipalFields.reduce((acc, field, index) => {
      acc[field.name] = row[index];
      return acc;
    }, {});
}

export const reverseTransformSingleRoadSign = (row) => {
    return roadSignFields.reduce((acc, field, index) => {
      acc[field.name] = row[index];
      return acc;
    }, {});
}